var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );
dependencies["front/utils/sites.jinja"] = require( "front/utils/sites.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/submissions/components/TopNav/TopNavDesktop.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/submissions/components/TopNav/TopNavDesktop.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n";
env.getTemplate("front/utils/sites.jinja", false, "assets/app/submissions/components/TopNav/TopNavDesktop.jinja", false, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
if(Object.prototype.hasOwnProperty.call(t_4, "SITE_AVAILABILITY")) {
var t_7 = t_4.SITE_AVAILABILITY;
} else {
cb(new Error("cannot import 'SITE_AVAILABILITY'")); return;
}
context.setVariable("SITE_AVAILABILITY", t_7);
output += "\n\n";
var macro_t_8 = runtime.makeMacro(
[], 
["request", "data", "page"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("request", Object.prototype.hasOwnProperty.call(kwargs, "request") ? kwargs["request"] : {});frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});frame.set("page", Object.prototype.hasOwnProperty.call(kwargs, "page") ? kwargs["page"] : "");var t_9 = "";t_9 += "\n    <a href=\"";
t_9 += runtime.suppressValue((lineno = 4, colno = 17, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["submissions:submissions"])), env.opts.autoescape);
t_9 += "\" class=\"TopNavDesktop-logo\">\n        ";
t_9 += runtime.suppressValue((lineno = 5, colno = 30, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"svgSprite"), "macros[\"svgSprite\"]", context, ["logo-header","0 0 160 80",runtime.makeKeywordArgs({"caller": (function (){var macro_t_10 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_11 = "";;
frame = frame.pop();
return new runtime.SafeString(t_11);
});
return macro_t_10;})()})])), env.opts.autoescape);
t_9 += "\n    </a>\n\n    <div class=\"TopNavDesktop-sidebar\">\n        <div class=\"TopNavDesktop-sidebarTable\">\n            <div class=\"TopNavDesktop-sidebarCell\">\n                <ul class=\"TopNavDesktop-sidebarList\">\n                    <li><a href=\"";
t_9 += runtime.suppressValue((lineno = 12, colno = 37, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["submissions:submissions"])), env.opts.autoescape);
t_9 += "\" class=\"";
if((runtime.contextOrFrameLookup(context, frame, "page") == "submissions")) {
t_9 += "TopNavDesktop-sidebarListItem--active";
;
}
t_9 += "\">SUBMISSIONS</a></li>\n                    <li><a href=\"";
t_9 += runtime.suppressValue((lineno = 13, colno = 37, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["submissions:rules"])), env.opts.autoescape);
t_9 += "\" class=\"";
if((runtime.contextOrFrameLookup(context, frame, "page") == "rules")) {
t_9 += "TopNavDesktop-sidebarListItem--active";
;
}
t_9 += "\">RULES & SPECIFICATIONS</a></li>\n                    <li><a href=\"";
t_9 += runtime.suppressValue((lineno = 14, colno = 37, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["submissions:help"])), env.opts.autoescape);
t_9 += "\" class=\"";
if((runtime.contextOrFrameLookup(context, frame, "page") == "help")) {
t_9 += "TopNavDesktop-sidebarListItem--active";
;
}
t_9 += "\">HELP</a></li>\n                    <li><a href=\"";
t_9 += runtime.suppressValue((lineno = 15, colno = 37, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["submissions:profile"])), env.opts.autoescape);
t_9 += "\" class=\"";
if((runtime.contextOrFrameLookup(context, frame, "page") == "profile")) {
t_9 += "TopNavDesktop-sidebarListItem--active";
;
}
t_9 += "\">PROFILE</a></li>\n                    <li><a class=\"TopNavDesktop-sidebarListItem--logout\">LOG OUT</a></li>\n                </ul>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"TopNavDesktop-sidebarLogo\">\n        ";
t_9 += runtime.suppressValue((lineno = 23, colno = 30, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"svgSprite"), "macros[\"svgSprite\"]", context, ["logo","0 0 160 150",runtime.makeKeywordArgs({"caller": (function (){var macro_t_12 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_13 = "";;
frame = frame.pop();
return new runtime.SafeString(t_13);
});
return macro_t_12;})()})])), env.opts.autoescape);
t_9 += "\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_9);
});
context.addExport("TopNavDesktop");
context.setVariable("TopNavDesktop", macro_t_8);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/submissions/components/TopNav/TopNavDesktop.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/submissions/components/TopNav/TopNavDesktop.jinja
// module id = 68
// module chunks = 0